export default __webpack_public_path__ + "static/media/logo.f255a673.png";